module.exports = __webpack_public_path__ + "adb2c729cf05820b2c35172ef1d465bc.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/dan-callahan.jpg
 ** module id = 405
 ** module chunks = 0
 **/